import { HttpContextToken } from '@angular/common/http';

/**
 * HTTP context token to mark requests that require credentials (session cookies).
 * Use this for BFF requests that need authentication.
 *
 * @example
 * ```typescript
 * return this.http.get<User>('/api/auth/status', {
 *   context: new HttpContext().set(REQUIRES_AUTH, true)
 * });
 * ```
 */
export const REQUIRES_AUTH = new HttpContextToken<boolean>(() => false);
